import { inject, Injectable } from '@angular/core';
import { IconKey } from '../../../whitelabel/icon-key.enum';
import { ICONSET_DEFAULT, ICONSET_MAP, IconsetKey } from '../../../whitelabel/iconset-key.enum';
import { WhitelabelManagerService } from './whitelabel-manager.service';

@Injectable({
  providedIn: 'root',
})
export class IconProviderService {

  private iconMap: { [iconset: string]: { [key: string]: string } } = {};
  private whitelabelManagerService = inject(WhitelabelManagerService);

  /**
   * Creates the icon map based on the whitelabel definitions
   */
  constructor() {
    const configurations = this.whitelabelManagerService.getAllWhitelabelConfigurations();
    for (const config of Object.values(configurations)) {
      if (!this.iconMap[config.iconSet]) {
        this.iconMap[config.iconSet] = ICONSET_MAP[config.iconSet]?.() ?? {};
      }
    }
  }

  /**
   * returns an icon identified by its iconKey.
   *
   * If the icon is not found in either the default icon set or the requested icon set, it returns a ?
   *
   * @param iconKey
   * @param iconset
   */
  public getIcon(iconKey: IconKey, iconset: IconsetKey = this.whitelabelManagerService.getWhitelabelIconSet() || ICONSET_DEFAULT): string {
    return this.iconMap[iconset]?.[iconKey] || '';
  }
}
